import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { me as fetchMe, logout as apiLogout } from '@/lib/adminApi';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchMe();
      setAdmin(data);
      return data;
    } catch (_) {
      setAdmin(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signOut = async () => {
    try {
      await apiLogout();
    } catch (_) {
      /* ignore */
    }
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, refresh, signOut, setAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
};
